module.exports = __webpack_public_path__ + "img/img_zertifizierung_02.9abb2ada.jpg";